import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useOrderProviderExternalErrorsFilterFields } from './hooks/useOrderProviderExternalErrorsFilterFields';

export type OrderProviderExternalErrorsFilterValues = {
  appliedDate?: DateRangeValue;
  createdAt: {
    gte: number;
    lte: number;
  };
  timezone?: DateRangeTimezoneValue;
  providerExternalError?: {
    isCritical: string | null;
    reason: string | null;
    category?: string[] | null;
  };
  merchant?: string[];
  provider?: string[];
  gateway?: string[];
  method?: string[];
  order: { direction: string | null; gateway?: string[] | null };
};

export const OrderProviderExternalErrorsFilter: React.FC = () => {
  const fields = useOrderProviderExternalErrorsFilterFields();

  return <FilterFields fields={fields} />;
};
